import API from '../../../utils/http/api'
import get from 'lodash/get'

// Action Types
const REQUEST = 'steppingblocks/searchHistory/REQUEST'
const SUCCESS = 'steppingblocks/searchHistory/SUCCESS'
const FAILURE = 'steppingblocks/searchHistory/FAILURE'
const START_JOB_SEARCH_POST = 'START_JOB_SEARCH_POST'
const SUCCESS_JOB_SEARCH_POST = 'SUCCESS_JOB_SEARCH_POST'
const ERROR_JOB_SEARCH_POST = 'ERROR_JOB_SEARCH_POST'

// Reducer
const initialState = {
  error: null,
  requestStarted: false,
  requestEnded: false,
  results: [],
  saveJobSearchError: null,
  savingJobSearch: false,
}

export default (reduxState = initialState, action) => {
  const { type, payload } = action
  switch (type) {
    case REQUEST:
      return {
        ...reduxState,
        requestStarted: true,
        requestEnded: false,
      }
    case SUCCESS:
      return {
        ...reduxState,
        requestEnded: true,
        results: payload.results,
      }
    case FAILURE:
      return {
        ...reduxState,
        requestEnded: true,
        error: payload.error,
      }
    case START_JOB_SEARCH_POST:
      return {
        ...reduxState,
        savingJobSearch: true
      }
    case SUCCESS_JOB_SEARCH_POST:
      return {
        ...reduxState,
        savingJobSearch: false
      }
    case ERROR_JOB_SEARCH_POST:
      return {
        ...reduxState,
        savingJobSearch: false,
        saveJobSearchError: payload.error
      }
    default:
      return reduxState
  }
}

export const performRetrieveMySearchHistory = () => async dispatch => {
  dispatch({ type: REQUEST })
  try {
    const { searchMades } = await API.get('/search_mades/by_me')
    dispatch({
      type: SUCCESS,
      payload: {
        results: searchMades,
      },
    })
    return searchMades
  } catch (error) {
    dispatch({
      type: FAILURE,
      payload: {
        error: error.message,
      },
    })
  }
}

export const performSaveJobSearch = (jobSearch) => async dispatch => {
  dispatch({ type: START_JOB_SEARCH_POST })

  const jobSearchToSave = {}
  if (get(jobSearch, 'location')) jobSearchToSave.location = get(jobSearch, 'location')
  if (get(jobSearch, 'radius')) jobSearchToSave.radius = get(jobSearch, 'radius')
  if (get(jobSearch, 'searchTerm')) jobSearchToSave.keywords = get(jobSearch, 'searchTerm')
  if (get(jobSearch, 'workFromHome')) jobSearchToSave.workFromHome = get(jobSearch, 'workFromHome')


  try {
    await API.post('search_mades/by_me/job_search', jobSearchToSave)
    dispatch({ type: SUCCESS_JOB_SEARCH_POST })
  } catch (error) {
    dispatch({
      type: ERROR_JOB_SEARCH_POST,
      payload: {
        error
      }
    })
  }
}

export const getSearchMades = state => state.searchHistory.results



// WEBPACK FOOTER //
// ./src/components/ui/SearchHistory/searchHistoryDuck.js